@if (type === 'disclaimer') {
  <a
    class="block text-center cursor-pointer text-white md:mr-7 py-3 md:inline-block"
    (click)="openCookieConsent()"
    >{{ label }}</a
  >
}
@if (type === 'preferences') {
  <a
    class="block text-center cursor-pointer text-white md:mr-7 py-3 md:inline-block"
    (click)="openPreferencesCenter()"
    >{{ label }}</a
  >
}
